import Router from "./Router";
import "bootstrap/dist/css/bootstrap.css";
import "./App.scss"
import TermsandConditions from "./components/TermsandConditions";
import Sidenav from "./views/navbar/Sidenav";
function App() {
  const privacy_policy_accepted = localStorage.getItem("privacy_policy_accepted");
  return (
    <div className="App">
      <Router />
      {privacy_policy_accepted == "false" &&
        <TermsandConditions />
      }
    </div>
  );
}

export default App;
